import React from 'react';
import './FooterBanner.css';

function FooterBanner() {
    return (
        <div className="footer__banner">
            
            <p className="description">
                Стань профессионалом в веб-разработке
            </p>

            <button>
                Начать бесплатно
            </button>
            
        </div>
    )
}

export default FooterBanner
